import styled, { css } from 'styled-components';

import { FADE_OUT_HEIGHT, MAX_HEIGHT } from './messagePreview.consts';

export const Wrapper = styled.section`
  cursor: pointer;
`;

type InnerProps = {
  maskEnabled: boolean;
};
export const Inner = styled.div<InnerProps>`
  border-left: 3px solid ${({ theme }) => theme.colors.iconGray};
  border-radius: 2px;
  overflow: hidden;
  ${({ maskEnabled }) =>
    maskEnabled &&
    css`
      mask-image: linear-gradient(
        to bottom,
        black 0% calc(90% - ${FADE_OUT_HEIGHT}px),
        transparent 90% 100%
      );
    `}
  max-height: ${MAX_HEIGHT}px;
  padding-left: 5px;
`;

export const Author = styled.strong`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
  line-height: 20px;
`;

export const ContentWrapper = styled.blockquote`
  border: 0;
  padding: 0;
  margin: 0;
  opacity: 0.8;
`;

export const AttachmentsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
`;
